const hostname = window.location.hostname;

export const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
export const isUzbekistan = hostname.startsWith("uz.oneplace.hr");
export const isKazakhstan = hostname.startsWith("kz.oneplace.hr");
export const isMongolia = !isUzbekistan && !isKazakhstan;

export const currentCountry = isUzbekistan ? "UZ" : isKazakhstan ? "KZ" : "MN";
